import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Modal, Button, ButtonToolbar} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import {supportWorker} from '../../core/browser'
import DayRangePicker from '../../core/components/DayRangePicker'
import {DEFAULT_TICKET_QUERY, REPORT_PDF_TICKETS_OPTION_UPDATED, reportPdfTickets, updateReportPdfTicketsOption} from '../actions'
import {PDF_REPORT_PAGES, ReportPdfTicketsOption} from '../models'
import i18n from '../i18n'

function pageFilter({patrimony, agency}) {
    return (page) => {
        if (patrimony && (page == 'patrimony' || page == 'agency')) return false
        if (agency && page == 'agency') return false
        return true
    }
}

class ReportTicketsModal extends Component {
    static propTypes = {
        patrimony: PropTypes.object,
        agency: PropTypes.object,
        onHide: PropTypes.func.isRequired
    }

    _reportPdf() {
        const {dispatch, option, patrimony, agency, onHide} = this.props

        const reportQuery = {
            from: option.from,
            to: option.to,
            patrimony: patrimony && patrimony.uid,
            agency: agency && agency.uid
        }

        const reportOption = {
            pages: PDF_REPORT_PAGES.filter(pageFilter({patrimony, agency}))
        }

        if (!supportWorker()) {
            // fallback on download
            const payload = {type: 'PdfTicketsReport', option: reportOption, ...reportQuery}
            const encodedPayload = btoa(JSON.stringify(payload))
            window.open('/download/' + encodedPayload, '_blank')
            onHide()
            return true
        }

        return Promise.resolve(dispatch(reportPdfTickets({...DEFAULT_TICKET_QUERY, ...reportQuery}, reportOption))).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, option, patrimony, agency, onHide, ...others} = this.props

        return (
            <Modal
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.exportTickets}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DayRangePicker
                        {...form(['from', 'to'])} />
                    <ButtonToolbar>
                        <Button
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._reportPdf() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.exportz}
                        </Button>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

ReportTicketsModal = connectForm({
    target: 'option',
    schema: ReportPdfTicketsOption.schema,
    action: REPORT_PDF_TICKETS_OPTION_UPDATED
})(ReportTicketsModal)

ReportTicketsModal = connect((state) => ({
    option: state.ticket.reportPdfTicketsOption
}))(ReportTicketsModal)

export default ReportTicketsModal


// WEBPACK FOOTER //
// ./lib/ticket/components/ReportTicketsModal.js